/**
 * Yataş "Hedeften Plana" — hesap zinciri yardımcıları.
 * Zincirdeki her adım EKRANDA GÖRÜNEN (yuvarlanmış) rakamlarla elle doğrulanabilmeli:
 * önceki rakamların gösterilen hâli × son katsayı = gösterilen sonuç (aynı hassasiyette).
 */

/** Para: Mn ≥ 1e6 → 2 ondalık (₺37,83 Mn), bin → tam bin, altı → tam lira (tlp ile aynı hassasiyet) */
export const rMoney = (v) => {
  const a = Math.abs(v);
  if (a >= 1e6) return Math.round(v / 1e4) * 1e4;
  if (a >= 1e3) return Math.round(v / 1e3) * 1e3;
  return Math.round(v);
};

export const rDec = (v, k) => Math.round(v * 10 ** k) / 10 ** k;

/**
 * Son katsayı: priorShown × f, roundRes hassasiyetinde resultShown'a eşit olana kadar ondalık artar (2–5).
 * @returns {{ value: number, digits: number, exact: boolean }}
 */
export function lastFactor(resultShown, priorShown, roundRes) {
  if (!priorShown || resultShown == null) return null;
  const f = resultShown / priorShown;
  for (let k = 2; k <= 5; k++) {
    const fk = rDec(f, k);
    if (roundRes(priorShown * fk) === roundRes(resultShown)) return { value: fk, digits: k, exact: true };
  }
  return { value: rDec(f, 5), digits: 5, exact: false };
}

export const facText = (lf) => (lf
  ? `×${lf.value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: lf.digits })}`
  : '—');
